import { get, upperFirst } from 'lodash-es'
import { compareValuesNullsLast } from '@/components/shared-table/utils'
import { buildColumnDef, getFormattedValue, getModelPredictionRoot } from '@/components/shared-table/buildColumnDef'

const getGroupValue = (predictionForModel) => {
  const value = get(predictionForModel, 'group')
  return value ? upperFirst(String(value)) : null
}

const buildArnCategoriesColumnDef = ({ column, visibleColumnIds, tableSettings }) =>
  buildColumnDef({
    column,
    visibleColumnIds,
    tableSettings,
    type: [],

    tooltipValueGetter: (params) => getGroupValue(params?.value),

    valueGetter: (params) => getModelPredictionRoot(params?.data?.predictionsByModelId, column?.modelId),

    valueFormatter: (params) =>
      getFormattedValue({
        params,
        column,
        formatFunction: () => getGroupValue(params?.value),
      }),

    comparator: (aValue, bValue, _nodeA, _nodeB, isDescending) =>
      compareValuesNullsLast(getGroupValue(aValue), getGroupValue(bValue), isDescending),

    cellClass: '',
  })

export { buildArnCategoriesColumnDef }
